interface IGeoData {
  lat: number
  lng: number
}

export const haversineDistance = (
  origin: IGeoData,
  target: IGeoData,
): number => {
  const R = 6371e3 // Earth radius in meters
  const toRad = (deg: number) => (deg * Math.PI) / 180

  const dLat = toRad(target.lat - origin.lat)
  const dLng = toRad(target.lng - origin.lng)
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(origin.lat)) *
      Math.cos(toRad(target.lat)) *
      Math.sin(dLng / 2) ** 2

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}

export const isWithinRange = (
  origin: IGeoData,
  target: IGeoData,
  rangeInMeters = 10,
) => {
  return haversineDistance(origin, target) <= rangeInMeters
}
